import {CSSProperties} from "react";
import {useContext} from "react";
import classNames from "classnames";

import {CloseIcon} from "@pg-design/icons-module";

import {ModalContext} from "../ModalContext";

import * as styles from "./ModalCloseButton.module.css";

interface IModalCloseButtonProps {
    placement?: "left" | "right";
    variant?: "default" | "rounded" | "none";
    className?: string;
    fillColor?: string;
    wrapperColor?: string;
    size?: string;
    style?: CSSProperties;
    onModalClose?: () => void;
}

export const ModalCloseButton = (props: IModalCloseButtonProps) => {
    const {className, fillColor, placement, size, style, variant = "default", wrapperColor} = props;
    const {onModalClose} = useContext(ModalContext);

    if (variant === "none") {
        return null;
    }

    const buttonSize = size ?? (variant === "rounded" ? "2.0" : "2.4");
    const fillColorStyle = fillColor ?? (variant === "rounded" ? "var(--colors-dark-4)" : "var(--colors.secondary)");
    const backgroundColorValue = wrapperColor ?? (variant === "rounded" ? "var(--colors-white)" : "transparent");

    const cn = classNames(className, styles.base, placement && styles[placement], variant === "rounded" && styles.rounded);

    return (
        <button type="button" onClick={onModalClose || onModalClose} className={cn} style={{...style, backgroundColor: backgroundColorValue}}>
            <CloseIcon size={buttonSize} wrapperSize={buttonSize} wrapperColor={wrapperColor} fill={fillColorStyle} />
        </button>
    );
};
import {CSSProperties} from "react";
import {useContext} from "react";
import classNames from "classnames";

import {CloseIcon} from "@pg-design/icons-module";

import {ModalContext} from "../ModalContext";

import * as styles from "./ModalCloseButton.module.css";

interface IModalCloseButtonProps {
    placement?: "left" | "right";
    variant?: "default" | "rounded" | "none";
    className?: string;
    fillColor?: string;
    wrapperColor?: string;
    size?: string;
    style?: CSSProperties;
    onModalClose?: () => void;
}

export const ModalCloseButton = (props: IModalCloseButtonProps) => {
    const {className, fillColor, placement, size, style, variant = "default", wrapperColor} = props;
    const {onModalClose} = useContext(ModalContext);

    if (variant === "none") {
        return null;
    }

    const buttonSize = size ?? (variant === "rounded" ? "2.0" : "2.4");
    const fillColorStyle = fillColor ?? (variant === "rounded" ? "var(--colors-dark-4)" : "var(--colors.secondary)");
    const backgroundColorValue = wrapperColor ?? (variant === "rounded" ? "var(--colors-white)" : "transparent");

    const cn = classNames(className, styles.base, placement && styles[placement], variant === "rounded" && styles.rounded);

    return (
        <button type="button" onClick={onModalClose || onModalClose} className={cn} style={{...style, backgroundColor: backgroundColorValue}}>
            <CloseIcon size={buttonSize} wrapperSize={buttonSize} wrapperColor={wrapperColor} fill={fillColorStyle} />
        </button>
    );
};
